import styled from 'styled-components';
import { Input } from 'antd';
import { Checkbox } from 'antd';

export const ContactForm = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 3rem;
    max-width: 1300px;
    margin: 0 auto;
    padding-left: 10vw;
    padding-right: 5vw;
    label {
        color: #fff !important;
        font-size: 1.1rem !important;
    }
    input {
        padding: 1.5rem;
    }
    color: #fff;
    .ant-form .ant-form-item-label label {
        font-size: .81rem !important;
        color: #ffffff9c !important;
    }
`;

export const DarkInput = styled(Input)`
    background: transparent !important;
    color: #fff !important;
    border: none !important;
    border-bottom: 2px solid #444 !important;
    border-radius: 0 !important;
    padding-left: 0 !important;
    font-size: 1rem !important;

    &::placeholder {
        color: #bbb !important;
        opacity: 1;
    }

    &:hover,
    &:focus {
        border-bottom: 2px solid #9549e7 !important;
        background: transparent !important;
        box-shadow: none !important;
    }

    &.ant-input-status-error {
        border-bottom: 2px solid #ff4d4f !important;
        box-shadow: none !important;
    }
`;

export const DarkTextArea = styled(Input.TextArea)`
    background: transparent !important;
    color: #fff !important;
    border: none !important;
    border-bottom: 2px solid #444 !important;
    border-radius: 0 !important;
    padding-left: 0 !important;
    font-size: 1rem !important;

    &::placeholder {
        color: #bbb !important;
        opacity: 1;
    }

    &:hover,
    &:focus {
        border-bottom: 2px solid #9549e7 !important;
        background: transparent !important;
        box-shadow: none !important;
    }

    &.ant-input-status-error {
        border-bottom: 2px solid #ff4d4f !important;
        box-shadow: none !important;
    }
`;

export const DarkCheckboxGroup = styled(Checkbox.Group)`
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 8px !important;
    max-width: 600px !important;

    .ant-checkbox-wrapper {
        color: #fff !important;
        font-size: 1.1rem !important;
        margin: 0 !important;
        padding: 0.25rem 0 !important;
        transition: color 0.3s;

        &:hover {
            color: #9549e7 !important;
        }
    }

    .ant-checkbox-inner {
        background: transparent !important;
        border: 2px solid #444 !important;
        border-radius: 4px !important;
        width: 18px;
        height: 18px;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
        background: #9549e7 !important;
        border-color: #9549e7 !important;
    }

    .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: #9549e7 !important;
        box-shadow: none !important;
    }
`;

export const Address = styled.div`
    color: #ffffffbd;
    font-size: 1rem;

    address {
        line-height: 1.5;
        margin: 0;
        font-style: normal;

        ul {
            list-style: none;
            padding: 0;
            margin-bottom: 1.5rem;

            li {
                margin-bottom: 0.5rem;
            }
        }
    }

    svg {
        width: 0.71rem;
        height: 0.71rem;
        margin-right: 0.5rem;
        color: #fff;
        fill: currentColor;
    }

    a {
        color: #fff;
        text-decoration: none;
        transition: color 0.3s ease;
        &:hover {
            color: #9549e7;
            svg {
                color: #9549e7;
            }
        }
    }
`;

export const SubmitButton = styled.button`
    padding: 0.75rem 2rem;
    margin-top: 1.5rem;
    background: #9549e7;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 600;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    svg {
        width: 1rem;
        height: 1rem;
        fill: currentColor;
    }

    &:hover {
        background: #7f3cc2;
    }
`;

export const LookingFor = styled.div`
    margin-top: 10rem;
    color: #fff;
    font-size: 1.1rem;
    display: grid;
    grid-template-columns: 1fr 300px;
    gap: 2rem;
    padding-left: 10vw;
    padding-right: 5vw;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        padding-left: 3vw;
        padding-right: 3vw;
    }

    h5 {
        margin-top: 0;
        margin-bottom: 0.5rem;
        font-weight: 600;
        text-transform: uppercase;
    }
    h1 {
        font-size: 3rem;
        font-weight: 400;
        margin-bottom: 1rem;
        span {
            font-weight: 800;
        }
    }
    p {
        margin-bottom: 1rem;
        font-size: 1rem;
        line-height: 1.5;
    }
`;
